import React, { useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthProvider';
import { can } from '../../utils/access';
import { STORAGE, STREAMING } from '../../utils/headers';
import noimg from '../../assets/img/noimg.jpg';

const streamingUrl = (model) => `${STREAMING}/${model?.streaming_token}`;

const ModelList = ({ models, onEdit, onDelete, onProfile, refresStreamingToken }) => {
  const { user } = useAuthContext();
  const [copiedId, setCopiedId] = useState(null);

  const copyToClipboard = (modelId, text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      setCopiedId(modelId);
      setTimeout(() => {
        setCopiedId((current) => (current === modelId ? null : current));
      }, 2000);
    });
  };

  // Cada acción se ofrece solo si su permiso la respalda: dar de baja a una
  // modelo le quita el rol, así que es cosa de quien gestiona personas, y la
  // clave de emisión la administra quien puede rotarla. Enseñarlas a todo el
  // que entra al panel solo producía un 403 al pulsarlas.
  const puedeGestionarClaves = can(user, 'manage_stream_keys');
  const puedeDarDeBaja = can(user, 'manage_users');
  // El aviso de "no hay modelos" colgaba dentro del contenedor con desplazamiento
  // horizontal, así que heredaba el ancho mínimo de la tabla y quedaba centrado
  // fuera de la pantalla. Sin filas no hay tabla que enseñar.
  if (models?.length === 0) {
    return (
      <div className="table-empty">
        <i className="fa-solid fa-users-slash" aria-hidden="true"></i>
        <p>No hay modelos registrados actualmente</p>
      </div>
    );
  }

  return (
    <div className="custom-table-container">
      <Table striped bordered hover className='custom-table text-center'>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>Perfil público</th>
            {puedeGestionarClaves && <th>Streaming URL / OBS</th>}
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {models?.map((model) => (
            <tr key={model.id}>
              <td data-label="Nombre" className="fw-bold text-white">
                <span className="model-cell">
                  <img
                    src={model?.img ? `${STORAGE}/${model.img}` : noimg}
                    onError={(e) => { e.target.onerror = null; e.target.src = noimg; }}
                    alt=""
                    className="model-cell-avatar"
                    width="36"
                    height="36"
                    loading="lazy"
                  />
                  <span>
                    {model?.user?.name}
                    {model?.stage_name && (
                      <small className="model-cell-stage">{model.stage_name}</small>
                    )}
                  </span>
                </span>
              </td>
              <td data-label="Email" className="fw-bold text-white cell-email">{model?.user?.email}</td>
              <td data-label="Perfil público">
                {/* Antes era texto dorado sin subrayado ni icono: parecía una
                    etiqueta más y nada indicaba que se pudiera pulsar. */}
                {model?.slug ? (
                  <Link
                    to={`/modelo/${model.slug}`}
                    className="profile-link"
                    title={`Ver el perfil público de ${model?.user?.name ?? 'la modelo'}`}
                  >
                    <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    <span>/modelo/{model.slug}</span>
                  </Link>
                ) : (
                  <span className="text-muted small">Sin publicar</span>
                )}
              </td>
              {puedeGestionarClaves && (
              <td data-label="Streaming URL / OBS">
                {/* La URL no parte por ningún sitio y estiraba la columna hasta
                    empujar "Acciones" fuera del área visible. Se recorta y el
                    texto completo queda en el `title` y en el botón de copiar. */}
                <div className={`token-copy-wrapper mx-auto ${copiedId === model.id ? 'is-copied' : ''}`}>
                    <span className="token-text" title={streamingUrl(model)}>{streamingUrl(model)}</span>
                    <Button
                      variant="link"
                      className={`p-0 ${copiedId === model.id ? 'text-success' : 'text-afrodita-gold'}`}
                      onClick={() => copyToClipboard(model.id, streamingUrl(model))}
                      title={copiedId === model.id ? "¡Copiado al portapapeles!" : "Copiar URL"}
                      aria-label={copiedId === model.id ? "URL copiada" : "Copiar URL"}
                    >
                        <i className={`fa-solid ${copiedId === model.id ? 'fa-check' : 'fa-copy'}`}></i>
                    </Button>
                    {copiedId === model.id && (
                      <span className="token-copied-badge">¡Copiado!</span>
                    )}
                </div>
              </td>
              )}
              <td data-label="Acciones">
                <div className="cell-actions">
                  <Button variant="outline-primary" className="btn-action-sm" onClick={() => onEdit(model)} title="Editar cuenta">
                    <i className="fa-solid fa-pen-to-square"></i>
                  </Button>
                  <Button variant="outline-warning" className="btn-action-sm" onClick={() => onProfile(model)} title="Perfil público y galería">
                    <i className="fa-solid fa-id-badge"></i>
                  </Button>
                  {puedeDarDeBaja && (
                    <Button variant="outline-danger" className="btn-action-sm" onClick={() => onDelete(model.id)} title="Dar de baja">
                      <i className="fa-solid fa-trash-can"></i>
                    </Button>
                  )}
                  {puedeGestionarClaves && (
                    <Button variant="outline-info" className="btn-action-sm" onClick={() => refresStreamingToken(model.id)} title="Rotar la clave de emisión">
                      <i className="fa-solid fa-arrows-rotate"></i>
                    </Button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ModelList;